import { Component, Input, OnInit, AfterViewInit,Renderer2,Inject } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup } from '@angular/forms';
import { RequestPayme } from '../../../modal/Payme/RequestPayme';
import { ProcesarPagoService } from 'src/app/service/procesarpago/procesar-pago.service';
import { OrderRequest } from '../../../modal/procesapago/orderRequest';
import { DetailBook } from '../../../modal/procesapago/detailBook';
import { OrderResponse } from '../../../modal/procesapago/orderResponse';
import { NovedadesService } from 'src/app/service/catalogo/novedades.service';
import { CarritoHeader } from 'src/app/modal/carrito/carrito-header';
import { CarritoService } from 'src/app/service/carrito/carrito.service';
import { LibroDetalle } from 'src/app/modal/catalogo/libro-detalle';
import { OrderCalculateRequest } from 'src/app/modal/procesapago/orderCalculateRequest';
import { CdkStep, CdkStepper } from '@angular/cdk/stepper';
import { UtilitarioService } from 'src/app/service/utilitarios/utilitario.service';
import { SourvenirDetalleResponse } from 'src/app/modal/sourvenir/sourvenir-detalle-response';
import { environment } from 'src/environments/environment';
import { AccesoRequest } from 'src/app/modal/niubiz/acceso-request';
import { AccesoResponse } from 'src/app/modal/niubiz/acceso-response';
import { DOCUMENT } from '@angular/common';
import { NiubizService } from 'src/app/service/niubiz/niubiz.service';
import { PrepagoConceptoRequest } from 'src/app/modal/niubiz/prepago-concepto-request';
import { UsuarioService } from 'src/app/service/usuario/usuario.service';
import { UsuarioResponse } from 'src/app/modal/usuario/usuario-response';

@Component({
  selector: 'app-medio-pago',
  templateUrl: './medio-pago.component.html',
  styleUrls: ['./medio-pago.component.scss']
})
export class MedioPagoComponent implements OnInit {

  constructor(private procesarPagoService:ProcesarPagoService,
              private carritoService:CarritoService,
              private novedadesService:NovedadesService,
              private utilitarioService:UtilitarioService,
              private _renderer2: Renderer2,
              private usuarioService:UsuarioService,
              @Inject(DOCUMENT) private _document: Document,
              private niubizService:NiubizService,
              private router: Router
              ) {
                this.obtenerAccesoPago();
              }

  @Input() orderRequest: OrderRequest;
  @Input() cdkStepper : CdkStepper;
  @Input() cdkStepOne : CdkStep;
  dataPago:any;
  baseURL=environment.urlBase;
  public stepTwo: FormGroup;
  carritoDetalle:CarritoHeader; 
  rdbpagotarjeta=true;    
  templateUnchecked = "DA";
  templateChecked = "TAR";
  template = "TAR";
  requestPayme = new RequestPayme();  
  precioTotal : number;
  cantidadTotal : number;
  weightTotal : number;
  usuarioSesion: UsuarioResponse;

  SubTotalTemp = 0;
  IGVProducto = 0;
  IGVDelivery = 0;
  IGVTotal = 0;

  // Moneda del carrito
  monedaCarrito: string = 'PEN'; // PEN o USD
  currencyCode: string = '604'; // 604 = PEN, 840 = USD    
  
  urlPayme:String;
  accesoRequest:AccesoRequest;
  accesoResponse:AccesoResponse;
  isLoadingPaymentButton: boolean = true;

  ngOnInit(): void {
    this.urlPayme = environment.urlPayme;
   // this.cargarPrepagoNiubiz();
   // this.onPagarPreorden();
  }
  ngOnChanges():void{
    this.onPagarPreorden();
  }
  obtenerDatosUsuario(){
    this.usuarioSesion = this.usuarioService.obtenerSesionUsuario();
   }

  cargarPrepagoNiubiz(orderResponse:OrderResponse) {
    this.isLoadingPaymentButton = true;
    this.obtenerDatosUsuario();
    let prepagoConceptoRequest:PrepagoConceptoRequest=new PrepagoConceptoRequest();
    prepagoConceptoRequest.codigoCliente=this.usuarioService.obtenerIDSessionUsuario();
    //debugger;
    prepagoConceptoRequest.codigocomercio=orderResponse.response.list[0].idCommerce; //COD EDITORA PERÚ
    prepagoConceptoRequest.correoCliente=orderResponse.response.list[0].shippingEmail;
    prepagoConceptoRequest.idpagoelectronico=orderResponse.response.list[0].orderNro;
    prepagoConceptoRequest.ip="172.16.88.209";
    prepagoConceptoRequest.mensaje="OK";
    prepagoConceptoRequest.nroDocumentoCliente=orderResponse.response.list[0].nroDocumentoCliente;
    prepagoConceptoRequest.resultado=1;
    prepagoConceptoRequest.tipoDocumentoCliente=orderResponse.response.list[0].tipoDocumentoCliente;
    prepagoConceptoRequest.totalpagar=Number(orderResponse.response.list[0].purchaseAmount);
    prepagoConceptoRequest.urljsgenerarboton=environment.urlNiubiz;
    // Pasar moneda a la pasarela de pagos
    prepagoConceptoRequest.moneda = this.monedaCarrito;
    prepagoConceptoRequest.currencyCode = this.currencyCode;
    // console.log("prepagoConceptoRequest",prepagoConceptoRequest);
    // console.log("💰 [MEDIO-PAGO] Enviando a Niubiz - Moneda:", this.monedaCarrito, "- CurrencyCode:", this.currencyCode);
    this.niubizService
      .registrarPrePagoConceptoPago(
        prepagoConceptoRequest    
      )
      .subscribe(
        (response) => {
          if (response.resultado == 1) { //CONSULTAR EN EL SERVICIO SI ES 1 O X
            
            this.dataPago = response.dato;
            // if (response.dato2?.actionCode == "000") {


              let form = document.createElement("form");
              form.setAttribute("method", "post");
              form.setAttribute(
                "action",
                this.baseURL +
                "api/pago-concepto/obtener-token-sesion-pasarela"+
                "?amount=" +
                response.dato.totalpagar +
                "&purchasenumber=" +
                response.dato.idpagoelectronico +
                "&currency=" +
                this.currencyCode
              );

              form.setAttribute("id", "boton_pago");
              document.getElementById("btn_pago").appendChild(form);
              let scriptEl = document.createElement("script");
              scriptEl.setAttribute("src", response.dato.urljsgenerarboton);
              scriptEl.setAttribute("data-formbuttoncolor", "#4341a6");
              scriptEl.setAttribute(
                "data-sessiontoken",
                response.dato.sesionkey.sessionKey
              );
              scriptEl.setAttribute(
                "data-merchantid",
                response.dato.codigocomercio
              );
              scriptEl.setAttribute(
                "data-merchantlogo",
                "https://archivohistorico.elperuano.pe/assets/image/editora_logo.png"
              );
              scriptEl.setAttribute(
                "data-purchasenumber",
                response.dato.idpagoelectronico
              );
              scriptEl.setAttribute("data-channel", "web");
              scriptEl.setAttribute("data-expirationminutes", "5");
              scriptEl.setAttribute("data-amount", response.dato.totalpagar);
              // Código de moneda: 604 = PEN (Soles), 840 = USD (Dólares)
              scriptEl.setAttribute("data-currency", this.currencyCode);
              scriptEl.setAttribute(
                "data-timeouturl",
                this.baseURL + "api/pago-concepto/timeout-pago"
              );
              // console.log("💰 [NIUBIZ] Botón configurado con moneda:", this.monedaCarrito, "- CurrencyCode:", this.currencyCode);

              // Guardar la moneda en localStorage para usarla al procesar el pago
              localStorage.setItem('niubiz_currency', this.monedaCarrito);
              localStorage.setItem('niubiz_currencyCode', this.currencyCode);

              document.getElementById("boton_pago").appendChild(scriptEl);

              // Ocultar skeleton después de un breve delay para que el script cargue
              setTimeout(() => {
                this.isLoadingPaymentButton = false;
              }, 1500);
          //  }
          } else {
            // console.log("Error");
            this.isLoadingPaymentButton = false;
            // this.errorLoadPage = true;
            // this.loadingPagoNiubiz = false;
          }
          // this.utilsService.ocultarCargando();
        },
        (error) => {
          // console.log("Error", error);
          this.isLoadingPaymentButton = false;
          // this.errorLoadPage = true;
          // this.loadingPagoNiubiz = false;
          // this.utilsService.ocultarCargando();
          // this.utilsService.abrirMensajeToken(null, null, null, error);
        }
      );
  }


  async onPagarPreorden(){
    this.utilitarioService.loading= true;
    //valida que exista un libro seleccionado
    if(this.carritoService.verificarCarritoSelecionados()==false){return;};

    this.carritoDetalle = new CarritoHeader();
    this.carritoDetalle=this.carritoService.obtenerCarritoCompras();

    this.precioTotal = 0;
    this.cantidadTotal = 0;
    this.weightTotal = 0;

    this.SubTotalTemp = 0;
    this.IGVDelivery = 0;
    this.IGVProducto = 0;
    this.IGVTotal = 0;

    // Estructura temporal para cargar productos y calcular descuentos
    const productosTemp = [];

    this.utilitarioService.loading=true;
    //obtiene nuevamente costos con BD por seguridad
    for (let i = 0; i < this.carritoDetalle.lista.length; i++) {
        
        let libroDetalleTemp=new LibroDetalle();
        let libroSourvenirTemp=new SourvenirDetalleResponse();

        let stockdisponible:number;
        //recorre carrito en temporal con bd para obtener costos y detalle del producto uno por uno
       if(this.carritoDetalle.lista[i].tipoProducto=="1"){

        // Enviar userId para determinar nacionalidad por tipo de documento
        const userId = this.usuarioService.obtenerIDSessionUsuario();
        var libroDetalle:LibroDetalle = await this.novedadesService.obtenerDetalleLibroAsync(this.carritoDetalle.lista[i].id, userId).toPromise();
       
        if (libroDetalle.response.codeResponse="0000"){
          libroDetalleTemp = libroDetalle;

          stockdisponible = Number(libroDetalleTemp.response.list[0].quantity) - Number(this.carritoDetalle.lista[i].cantidad);
          if(stockdisponible<0){
            this.utilitarioService.toastrInfo("No hay stock disponible en el libro " + libroDetalleTemp.response.list[0].title + ", cantidad disponible: " + libroDetalleTemp.response.list[0].quantity);
            this.utilitarioService.loading=false;
            return;
          }
          this.SubTotalTemp = Number((this.SubTotalTemp + ( Number(this.carritoDetalle.lista[i].cantidad) * Number(libroDetalleTemp.response.list[0].price_base))).toFixed(2));
          let modalidadEncontrada = libroDetalleTemp.response.list[0].modalidades.find(data=>
            data.id==this.carritoDetalle.lista[i].modalidadId
          );

          // Si la modalidad no existe (cambió de país), limpiar carrito y redirigir
          if (!modalidadEncontrada) {
            this.carritoService.limpiarCarrito();
            this.utilitarioService.toastrWarning('Tu carrito fue limpiado porque tu ubicación cambió. Los precios varían según tu país.');
            this.router.navigate(['/']);
            return;
          }

          let precio = modalidadEncontrada.price;

          // Determinar moneda del carrito basándose en el primer producto
          if (i === 0 && modalidadEncontrada && modalidadEncontrada.currency) {
            const currency = modalidadEncontrada.currency;
            if (currency === '$' || currency === 'USD' || currency === 'US$' ||
                currency.toLowerCase().includes('dolar') || currency.toLowerCase().includes('dollar')) {
              this.monedaCarrito = 'USD';
              this.currencyCode = '840'; // Código Niubiz para USD
            } else {
              this.monedaCarrito = 'PEN';
              this.currencyCode = '604'; // Código Niubiz para PEN
            }
            // console.log('💰 [MEDIO-PAGO] Moneda detectada:', this.monedaCarrito, '- Código:', this.currencyCode);
          }

          // Agregar a estructura temporal para agrupación de descuentos
          productosTemp.push({
            categoria: this.obtenerCategoria(libroDetalleTemp.response.list[0].categoryName),
            modalidadId: this.carritoDetalle.lista[i].modalidadId,
            cantidad: Number(this.carritoDetalle.lista[i].cantidad),
            precioUnitario: Number(precio)
          });

          this.cantidadTotal = this.cantidadTotal + Number(this.carritoDetalle.lista[i].cantidad);
          this.weightTotal = this.weightTotal + ( Number(this.carritoDetalle.lista[i].cantidad) *  Number(libroDetalleTemp.response.list[0].weight) );
        }
        }
        else if(this.carritoDetalle.lista[i].tipoProducto=="2"){

          var libroSourvenir:SourvenirDetalleResponse = await this.novedadesService.obtenerDetalleSourvenirAsync(this.carritoDetalle.lista[i].id).toPromise();
         
          if (libroSourvenir.response.codeResponse="0000"){

            //if have size
            if(libroSourvenir.response.list[0].size.length>0){              
              const result = libroSourvenir.response.list[0].size.find( ({ id }) => id ==  this.carritoDetalle.lista[i].sizeID);
              libroSourvenir.response.list[0].quantity = result.stock;              
            }

            libroSourvenirTemp = libroSourvenir;
  
            stockdisponible = Number(libroSourvenirTemp.response.list[0].quantity) - Number(this.carritoDetalle.lista[i].cantidad);
            if(stockdisponible<0){
              this.utilitarioService.toastrInfo("No hay stock disponible en el producto " + libroSourvenirTemp.response.list[0].title + ", cantidad disponible: " + libroSourvenirTemp.response.list[0].quantity);
              this.utilitarioService.loading=false;
              return;
            }
            // Para souvenirs, usar precio directo sin agrupación de descuentos
            let precioSouvenir = Number(libroSourvenirTemp.response.list[0].price);
            productosTemp.push({
              categoria: 'souvenir',
              modalidadId: null,
              cantidad: Number(this.carritoDetalle.lista[i].cantidad),
              precioUnitario: precioSouvenir
            });

            this.cantidadTotal = this.cantidadTotal + Number(this.carritoDetalle.lista[i].cantidad);
            this.weightTotal = this.weightTotal + ( Number(this.carritoDetalle.lista[i].cantidad) *  Number(libroSourvenirTemp.response.list[0].weight) );

            let tempPrecioSinIGV = 0;
            tempPrecioSinIGV =  Number((Number(libroSourvenirTemp.response.list[0].price) / 1.18).toFixed(2));


             this.IGVProducto = this.IGVProducto +   (Number(libroSourvenirTemp.response.list[0].price) - tempPrecioSinIGV ) * Number(this.carritoDetalle.lista[i].cantidad);


            this.SubTotalTemp = Number((this.SubTotalTemp + ( Number(this.carritoDetalle.lista[i].cantidad) * tempPrecioSinIGV)).toFixed(2));
  
          }       


        }else{
          this.utilitarioService.toastrInfo(libroDetalle.response.response);
          this.utilitarioService.loading=false;
          return;
        }

    }

    // Calcular total con descuentos por agrupación
    const totalCalculado = this.calcularTotalConDescuentos(productosTemp);
    this.precioTotal = totalCalculado;

    let orderCalculateRequest = new OrderCalculateRequest();
    orderCalculateRequest.addressId = this.orderRequest.addressId;
    orderCalculateRequest.amount = this.precioTotal.toString();
    orderCalculateRequest.quantity= this.cantidadTotal.toString();
    orderCalculateRequest.typeDeliveryId = "10"; //tipo entrega
    orderCalculateRequest.typeShippingId = this.orderRequest.typeShippingId; //codigo pais peru
    orderCalculateRequest.weight = this.weightTotal.toString();
    // console.log(this.orderRequest);

    
    // console.log("orderCalculateRequest",orderCalculateRequest);


    this.procesarPagoService.obtenerCalculoTotales(orderCalculateRequest).subscribe(data => {
      // console.log("obtenerCalculoTotales",data);
      //console.log("obtener totales");
      if (data.response.codeResponse!="0000"){//console.log(data); 
      this.utilitarioService.toastrError("Ocurrio un error en el servicio, no se ha efectuado el pago de la compra");return;}

      this.IGVDelivery = Number(data.response.list[0].igvCost);
      this.IGVTotal = this.IGVProducto + this.IGVDelivery;

      //obtiene por seguridad datos totales con la bd
    //  this.orderRequest.igvCost = data.response.list[0].igvCost;
      this.orderRequest.totalCost = data.response.list[0].totalCost;
      this.orderRequest.shippingCost = data.response.list[0].shippingCost;
    //  this.orderRequest.subtotalCost = data.response.list[0].subtotalCost;
      this.orderRequest.subtotalCost = this.SubTotalTemp.toString();
      this.orderRequest.igvCost = this.IGVTotal.toString();
     
      //REGISTRA ORDEN
      // Agregar codigo de moneda al orderRequest antes de enviar
      this.orderRequest.currencyCode = this.currencyCode;
      // console.log("💰 [MEDIO-PAGO] Enviando orden con currencyCode:", this.currencyCode);
      // console.log("orderRequest",JSON.stringify(this.orderRequest));


      if(this.orderRequest.clientId==null || this.orderRequest.clientId==""){
        return false;
      }

//debugger;
      this.procesarPagoService.grabarOrden(this.orderRequest).subscribe(data=>{
          // console.log(data);
          if (data.response.codeResponse=="0000"){
            // console.log("genera orden");
            this.cargarPrepagoNiubiz(data)
                     this.utilitarioService.loading=false;

          }else{
            this.utilitarioService.toastrError(data.response.response);
            this.utilitarioService.loading=false;
          }
      },
      (err:any) => {
        this.utilitarioService.toastrError("Ocurrio un error en el Servicio");
        // console.log(err);
      });
    },
    (err:any) => {
      this.utilitarioService.toastrError("Ocurrio un error en el Servicio");
      // console.log(err);
    });   

  }

  obtenerAccesoPago(){
    

  }

  CargarDatosPaymeRequest(orderResponse:OrderResponse) {
   
    this.requestPayme.acquirerId= orderResponse.response.list[0].acquirerId;
    this.requestPayme.idCommerce= orderResponse.response.list[0].idCommerce;
    this.requestPayme.purchaseOperationNumber = orderResponse.response.list[0].purchaseOperationNumber;
    this.requestPayme.purchaseAmount = orderResponse.response.list[0].purchaseAmount;
    this.requestPayme.purchaseCurrencyCode = orderResponse.response.list[0].purchaseCurrencyCode;
    this.requestPayme.language = orderResponse.response.list[0].language;
    this.requestPayme.shippingFirstName = orderResponse.response.list[0].shippingFirstName;
    this.requestPayme.shippingLastName = orderResponse.response.list[0].shippingLastName;
    this.requestPayme.shippingEmail = orderResponse.response.list[0].shippingEmail;
    this.requestPayme.shippingAddress = orderResponse.response.list[0].shippingAddress;
    this.requestPayme.shippingZIP = orderResponse.response.list[0].shippingZIP;
    this.requestPayme.shippingCity= orderResponse.response.list[0].shippingCity;
    this.requestPayme.shippingState= orderResponse.response.list[0].shippingState;
    this.requestPayme.shippingCountry = orderResponse.response.list[0].shippingCountry;
    this.requestPayme.shippingPhone = orderResponse.response.list[0].shippingTelephone;
    this.requestPayme.userCommerce = orderResponse.response.list[0].userCommerce;
    this.requestPayme.userCodePayme = orderResponse.response.list[0].userCodePayme;
    this.requestPayme.descriptionProducts = orderResponse.response.list[0].descriptionProducts;
    this.requestPayme.programmingLanguage = orderResponse.response.list[0].programmingLanguage;
    this.requestPayme.purchaseVerification = orderResponse.response.list[0].purchaseVerification; 
 
   }

   onBack(){
    this.cdkStepOne.completed=false;
    this.cdkStepper.previous();
   }

  // ========== MÉTODOS PARA CÁLCULO DE DESCUENTOS POR AGRUPACIÓN ==========

  /**
   * Identifica la categoría del producto
   */
  obtenerCategoria(categoryName: string): string {
    if (!categoryName) return 'otro';

    const catUpper = categoryName.toUpperCase();
    if (catUpper.includes('FOTOGRAFIA')) return 'fotografia';
    if (catUpper.includes('PORTADA')) return 'portada';
    return 'otro';
  }

  /**
   * Agrupa productos por categoría y modalidad, y calcula el total con descuentos
   */
  calcularTotalConDescuentos(productos: any[]): number {
    // Estructura para agrupar: Map<"categoria-modalidadId", {cantidad, precioUnitario}>
    const grupos = new Map<string, {totalUnidades: number, precioUnitario: number, categoria: string, modalidadId: string}>();

    // 1. Agrupar productos por categoría + modalidad
    productos.forEach(prod => {
      // Souvenirs no se agrupan para descuentos
      if (prod.categoria === 'souvenir') {
        const key = `souvenir-${Math.random()}`; // Clave única para cada souvenir
        grupos.set(key, {
          totalUnidades: prod.cantidad,
          precioUnitario: prod.precioUnitario,
          categoria: 'souvenir',
          modalidadId: null
        });
        return;
      }

      // Para fotografías y portadas: agrupar por categoria-modalidad
      const key = `${prod.categoria}-${prod.modalidadId}`;

      if (grupos.has(key)) {
        const grupo = grupos.get(key);
        grupo.totalUnidades += prod.cantidad;
      } else {
        grupos.set(key, {
          totalUnidades: prod.cantidad,
          precioUnitario: prod.precioUnitario,
          categoria: prod.categoria,
          modalidadId: prod.modalidadId
        });
      }
    });

    // 2. Calcular total aplicando descuentos por grupo
    let totalGeneral = 0;

    grupos.forEach((grupo, key) => {
      const { totalUnidades, precioUnitario } = grupo;

      // Si es souvenir, calcular sin descuentos
      if (key.startsWith('souvenir-')) {
        totalGeneral += totalUnidades * precioUnitario;
        return;
      }

      // Aplicar reglas de descuento según cantidad
      let subtotal = 0;

      if (totalUnidades >= 1 && totalUnidades <= 4) {
        // Sin descuento
        subtotal = totalUnidades * precioUnitario;

      } else if (totalUnidades === 5) {
        // Pack de 5: pagas 4, llevas 5 (20% descuento efectivo)
        subtotal = 4 * precioUnitario;

      } else if (totalUnidades >= 6 && totalUnidades <= 24) {
        // 20% de descuento
        const precioConDescuento = precioUnitario * 0.8;
        subtotal = totalUnidades * precioConDescuento;

      } else if (totalUnidades >= 25) {
        // 28% de descuento total (20% + 10% adicional)
        const precioConPrimerDescuento = precioUnitario * 0.8;
        const precioFinal = precioConPrimerDescuento * 0.9;
        subtotal = totalUnidades * precioFinal;
      }

      totalGeneral += subtotal;
    });

    return Number(totalGeneral.toFixed(2));
  }

}
